export default {
    my: { scope: 'my', statuses: [4, 3, 2, 5, 1] }, // все, кроме «Закрыто»
};
